import { useState, useEffect } from 'react';
import { Unit } from '../components/ServiceItem';
import { INFO_GENERIC_RULES_ACTION, INFO_GENERIC_RULES_WHEN } from '../utils/constants';
import { convertRichUnitToUnit } from '../models/AttendanceUnit';
import { ScheduleItemProps } from '../models/Schedule';
import { fetchBrancheById } from '../modules/attendanceUnits';
import { PAGES } from '../Router/pages';
import { useGenericModals } from '../store/genericModals';
import { AdditionalInformations } from '../modules/validateRules';
import { Rule } from '../models/Product';
import { handleGenericModals } from '../utils/genericModals';

type useGenericModalProps = {
  goTo?: (routeId: number) => void;
  findAnotherDoctor?: () => Promise<void>;
  schedule?: ScheduleItemProps;
};

export type ResponseGenericModal = {
  action: string;
  data: any;
};

export type ResourcePerUnit = {
  idResource: string;
  unitId: string;
};

export type UnitsAndResources = {
  units: Unit[];
  resources: ResourcePerUnit[];
};

export function useGenericModal({ goTo, findAnotherDoctor, schedule }: useGenericModalProps) {
  const genericModals = useGenericModals(state => state.genericModals);
  const setGenericModals = useGenericModals(state => state.setGenericModals);
  const [genericModalCondition, setGenericModalCondition] = useState('');
  const [modalGenericVisible, setModalGenericVisible] = useState(false);
  const [genericModalWhen, setGenericModalWhen] = useState('');

  const addGenericModals = ({
    additional,
    productRules
  }: {
    additional?: AdditionalInformations[];
    productRules?: Rule[];
  }) => {
    let additionalModals = [] as AdditionalInformations[];
    let genericModalRules = [] as AdditionalInformations[];
    if (productRules) {
      const genericModals = handleGenericModals(productRules);
      if (genericModals) genericModalRules = genericModals;
    }
    if (additional) additionalModals = additional;
    const modals = [...additionalModals, ...genericModalRules];
    setGenericModals(modals);
    return modals;
  };

  function handleModalProps(props: { condition?: string; visible: boolean }) {
    if (props.condition) setGenericModalCondition(props.condition);
    setModalGenericVisible(props.visible);
  }

  async function handleActionButtonModal(actionButton: string, data: any) {
    if (actionButton === INFO_GENERIC_RULES_ACTION.TO_SERVICE_TYPE) goTo && goTo(PAGES.SERVICE_TYPE_PAGE.id);

    if (actionButton === INFO_GENERIC_RULES_ACTION.OPEN_MODAL_CONDITION) setGenericModalCondition(data);

    if (actionButton === INFO_GENERIC_RULES_ACTION.CHANGE_PRODUCT) {
      setModalGenericVisible(false);
      return {
        action: INFO_GENERIC_RULES_ACTION.CHANGE_PRODUCT
      } as ResponseGenericModal;
    }

    if (actionButton === INFO_GENERIC_RULES_ACTION.FIND_ANOTHER_DOCTOR) {
      setModalGenericVisible(false);
      return {
        action: INFO_GENERIC_RULES_ACTION.FIND_ANOTHER_DOCTOR
      } as ResponseGenericModal;
    }

    if (actionButton === INFO_GENERIC_RULES_ACTION.CLOSE_MODAL) setModalGenericVisible(false);

    if (actionButton === INFO_GENERIC_RULES_ACTION.OPEN_WHATSAPP) window.open(`https://wa.me/${data}`);
    if (actionButton === INFO_GENERIC_RULES_ACTION.MAKE_A_CALL) window.location.href = `tel:${data}`;

    if (actionButton === INFO_GENERIC_RULES_ACTION.FIND_SLOTS_BY_UNIT_SPECIALIST)
      if (data.units && data.resources) {
        setModalGenericVisible(false);
        const resources = data.resources as ResourcePerUnit[];
        const units = [] as Unit[];
        const unitsRequests = [] as Promise<void>[];
        resources.map(async item => {
          const getUnit = async () => {
            const unit = await fetchBrancheById(item.unitId);
            units.push(convertRichUnitToUnit(unit));
          };
          unitsRequests.push(getUnit());
        });

        await Promise.all(unitsRequests);

        return {
          action: INFO_GENERIC_RULES_ACTION.FIND_SLOTS_BY_UNIT_SPECIALIST,
          data: { units, resources } as UnitsAndResources
        } as ResponseGenericModal;
      }
    if (actionButton === INFO_GENERIC_RULES_ACTION.FIND_SLOTS_WITHOUT_RESOURCEID)
      return {
        action: INFO_GENERIC_RULES_ACTION.FIND_SLOTS_WITHOUT_RESOURCEID,
        data: {}
      } as ResponseGenericModal;
  }

  function openModal(when: string, condition: string) {
    setGenericModalWhen(when);
    setGenericModalCondition(condition);
    setModalGenericVisible(true);
  }

  return {
    genericModalCondition,
    setGenericModalCondition,
    handleActionButtonModal,
    modalGenericVisible,
    setModalGenericVisible,
    handleModalProps,
    addGenericModals,
    genericModalWhen,
    setGenericModalWhen,
    openModal
  };
}
